module.exports = __webpack_public_path__ + "img/moj-old-logo.d17a127d.png";